export default (theme) => ({
  toggleFiltersBtn: {
    height: 40,
    width: '100%',
  },
  filtersIcon: {
    marginRight: 10,
  }
})
